package team.platforma.chat_data.database.messages

import app.cash.sqldelight.async.coroutines.awaitAsOne
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.emptyFlow
import team.platforma.chat_data.model.SendMessageData
import team.platforma.chatdata.database.ChatDatabase
import team.platforma.chatdata.table.MokMessage

class MokMessagesTableImpl(
    private val chatDatabase: ChatDatabase
) : MokMessagesTable {
    override suspend fun createNewTableMessage(message: SendMessageData): Long {
        var id = -1L
        chatDatabase.transaction {
            chatDatabase.mokMessageQueries.insertMessage(
                chatId = message.chatId,
                aiModelId = message.aiModelId,
                userId = message.userID,
                textMessage = message.textMessage,
                status = message.status,
                senderId = message.senderId
            )
            id = chatDatabase.mokMessageQueries.createMessageId().awaitAsOne()
        }
        return id
    }

    override suspend fun updateMessage(chatId: Long, tableMessageId: Long, status: String) {
        chatDatabase.mokMessageQueries.updateMessage(
            chatId = chatId,
            id = tableMessageId,
            status = status
        )
    }

    override suspend fun updateMessageText(
        chatId: Long,
        tableMessageId: Long,
        status: String,
        text: String
    ) {
        chatDatabase.mokMessageQueries.updateMessageText(
            chatId = chatId,
            id = tableMessageId,
            status = status,
            textMessage = text
        )
    }

    override fun observeMessages(
        aiModelId: Long?,
        userId: Long,
        chatId: Long
    ): Flow<List<MokMessage>> {
        return aiModelId?.let { modelId ->
            chatDatabase.mokMessageQueries.observeMessages(modelId, userId, chatId).asFlow()
                .mapToList(Dispatchers.Default)
        } ?: emptyFlow()
    }

    override suspend fun deleteMessage(id: Long) {
        chatDatabase.mokMessageQueries.deleteMessageById(id)
    }


}